if (!customElements.get("product-compatibility")) {
	class ProductCompatibility extends HTMLElement {
		constructor() {
			super(),
				this.selectors = {
					compatibility: [".product-compatibility"],
					medias: [".media-item"]
				},
				this.domNodes = queryDomNodes(this.selectors, this)
		}
		connectedCallback() {
			this.productId = this.dataset.productId,
				this.initVariantChange(),
				this.waitForPhotoswipe().then(() => {
					this.handlePhotoswipe()
					this.initPhotoswipe()
				})
		}

		waitForPhotoswipe() {
			return new Promise((resolve) => {
				if (window.ThemeLibs && window.ThemeLibs.PhotoSwipeLightbox) {
					resolve();
				} else {
					const interval = setInterval(() => {
						if (window.ThemeLibs && window.ThemeLibs.PhotoSwipeLightbox) {
							clearInterval(interval);
							resolve();
						}
					}, 100);
				}
			});

		}
		initVariantChange() {
			if (this.dataset.variantId == undefined) {
				this.domNodes.compatibility.forEach(e => {
					e.classList.add('hidden')
				})
			}
			this.handleVariantChange()
		}
		handleVariantChange() {
			ThemeEvents.subscribe(Theme.pubSubEvents.variantChange, (variant) => {
				if (variant) {
					this.domNodes.compatibility.forEach(e => {
						e.dataset.variant == variant.data.variant.id ? e.classList.remove('hidden') : e.classList.add('hidden')
					})
				}
			}
			)
		}
		initPhotoswipe() {
			this.lightbox.init();

			const handleMediaClick = (e, media) => {
				e.preventDefault();
				const index = Number(media.dataset.index) || 0;
				this.lightbox.loadAndOpen(index);
			};

			addEventDelegate({
				selector: this.selectors.medias[0],
				context: this,
				handler: handleMediaClick,
			});
		}
		handlePhotoswipe(customData = []) {
			const medias = [...this.querySelectorAll(".media-item")];

			const data = medias.map((media) => {
				const { index: id } = media.dataset;
				const {
					mediaSrc: src,
					mediaWidth,
					mediaHeight,
					mediaAlt: alt,
				} = media.querySelector(".media-image").dataset;
				return {
					src,
					width: parseInt(mediaWidth),
					height: parseInt(mediaHeight),
					alt,
					id,
				};
			});

			const options = {
				dataSource: customData.length ? customData : data,
				bgOpacity: 1,
				close: false,
				zoom: false,
				arrowNext: false,
				arrowPrev: false,
				counter: false,
				preloader: false,
				pswpModule: ThemeLibs.PhotoSwipeLightbox.PhotoSwipe,
			};
			this.lightbox = new ThemeLibs.PhotoSwipeLightbox(options);

			// UI elements
			const uiElements = [
				{
					name: "m-close",
					order: 11,
					isButton: true,
					html: '<svg class="svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>',
					onClick: (event, el, pswp) => pswp.close(),
				},
				{
					name: "caption",
					order: 0,
					isButton: false,
					html: '',
					onInit: (el, pswp) => {
						el.style.pointerEvents = 'none';
						el.style.fontSize = '20px';
						el.style.zIndex = '1000';

						pswp.on('change', () => {
							const currSlide = pswp.currSlide;
							if (currSlide && currSlide.data && currSlide.data.alt) {
								el.innerHTML = currSlide.data.alt;
							} else {
								el.innerHTML = '';
							}
						});
					}
				}
			];

			this.lightbox.on("uiRegister", () => {
				this.lightbox.pswp.ui.registerElement(uiElements[0]);
				uiElements.slice(1).forEach((element) => this.lightbox.pswp.ui.registerElement(element));
			});
		}
	}
	customElements.define("product-compatibility", ProductCompatibility)
}